(function () {
  angular
    .module('MktzapApp.Controllers')
    .controller('JobsWorkerController', JobsWorkerController);

  JobsWorkerController.$inject = ['$rootScope', 'NotificationService', 'FoundationApi', 'JobsWorkerService'];

  function JobsWorkerController ($rootScope, NotificationService, FoundationApi, JobsWorkerService) {
    var vm = this

    vm.workers = {}
    vm.worker = {
      action: '',
      selected: {},
      json: '',
      valid: '',
      duplicates: []
    }
    vm.formatting = {}
    vm.confirmDelete = false

    getAll()

    function getAll() {
      JobsWorkerService
        .all()
        .$promise
        .then(function (data) {
          vm.workers = data
        })
        .catch(function (error) {
          showNotification('error', $rootScope.labels.AnErrorOccurredLoadingWorkers)
        })
    }

    vm.edit = (worker) => {
      vm.worker.action = 'edit'
      vm.worker.selected = worker
      vm.worker.json = JSON.stringify(worker, null, 2)

      vm.checkWorkerIsValid()

      FoundationApi.publish('editWorkerModal', 'open')
    }

    vm.btnSave = () => {
      if (vm.worker.action === 'create') {
        vm.create()
      }

      if (vm.worker.action === 'edit') {
        vm.update()
      }
    }

    vm.btnCreate = () => {
      vm.worker = {}
      vm.worker.action = 'create'
      vm.formatting = {}

      FoundationApi.publish('editWorkerModal', 'open')
    }

    vm.btnDelete = () => {
      vm.confirmDelete = false

      FoundationApi.publish('comfirmDeleteWorkerModal', 'open')
    }

    vm.btnConfirmDelete = () => {
      JobsWorkerService
        .delete({
          id: vm.worker.selected._id
        })
        .$promise
        .then(function (data) {
          if (data && data.result) {
            showNotification(data.status, data.message)
            FoundationApi.publish('editWorkerModal', 'close')
            FoundationApi.publish('comfirmDeleteWorkerModal', 'close')
            getAll()
          }
        })
        .catch(function (error) {
          showNotification(error.data.status, error.data.message)
        })
    }

    vm.update = () => {
      JobsWorkerService
        .update({
          worker: JSON.parse(vm.worker.json)
        })
        .$promise
        .then(function (data) {
          if (data && data.result) {
            showNotification(data.status, data.message)
            FoundationApi.publish('editWorkerModal', 'close')
            getAll()
          }
        })
        .catch(function (error) {
          showNotification(error.data.status, error.data.message)
        })
    }

    vm.create = () => {
      JobsWorkerService
        .create({
          worker: JSON.parse(vm.worker.json)
        })
        .$promise
        .then(function (data) {
          if (data && data.result) {
            showNotification(data.status, data.message)
            FoundationApi.publish('editWorkerModal', 'close')
            getAll()
          }
        })
        .catch(function (error) {
          showNotification(error.data.status, error.data.message)
        })
    }

    vm.checkWorkerIsValid = () => {
      vm.checkJsonIsValid()
      vm.worker.duplicates = getAllDuplicateElements(JSON.parse(vm.worker.json).commands)
    }

    vm.checkJsonIsValid = () => {
      if (vm.worker.json === '') {
        vm.formatting = {}
        return
      }

      try {
        JSON.parse(vm.worker.json)
        vm.formatting = { color: 'green', 'background-color': '#d0e9c6' }
        vm.worker.valid = true
      } catch (e) {
        vm.formatting = { color: 'red', 'background-color': '#f2dede' }
        vm.worker.valid = false
      }
    }

    function getAllDuplicateElements(myArray) {
      let valuesDuplicate = []
      let isDuplicate = false

      myArray.forEach((currentValue, index, array) => {
        if (array.indexOf(currentValue, index + 1) !== -1) {
          isDuplicate = true

          if (valuesDuplicate.indexOf(currentValue) === -1) {
            valuesDuplicate.push(currentValue)
          }
        }
      })

      if (isDuplicate) {
        return valuesDuplicate
      }

      return isDuplicate
    }

    function showNotification(type, message) {
      if (type === 'success') {
        NotificationService.successHandler('', message)
      }

      if (type === 'warning') {
        NotificationService.warningHandler('', message)
      }

      if (type === 'error') {
        NotificationService.errorHandler('', message || $rootScope.labels.ProcessingError)
      }
    }
  }
})();
